import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <span className="font-heading font-extrabold text-[7rem] md:text-[10rem] leading-none text-primary-500/20 select-none">
        404
      </span>
      <h1 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 -mt-6">
        页面走丢了
      </h1>
      <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
      <p className="mt-3 text-sm text-foreground-700">
        你访问的页面不存在，回到首页继续发现精彩漫画吧
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-100 border border-background-300 text-foreground-950 text-sm font-medium hover:border-primary-400 transition-colors whitespace-nowrap"
        >
          <i className="ri-compass-3-line" />
          浏览漫画
        </Link>
      </div>
    </div>
  );
}